import { collection, onSnapshot, where, query } from "firebase/firestore";
import { db, auth } from "../firebaseConfig";
import { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import ReactPaginate from 'react-paginate';
import { useNavigate } from "react-router-dom";
import { Text } from "slate";
import BulkEdit from "./BulkEdit";
import UserNavbar from "../components/UserNavbar";
import ViolationCard from "../components/ViolationCard";

function UserDash() {
    const navigate = useNavigate();
    const userAuth = auth.currentUser;
    const [violations, setViolations] = useState([]);
    const [violationTitleInput, setViolationTitleInput] = useState("");
    const [sortValue, setSortValue] = useState("");
    const [editViolation, setEditViolation] = useState(null);
    const [bulkCheck, setBulkCheck] = useState(false);
    
    const filteredViolations = violations.filter(v =>
        v.arsCode.toLowerCase().includes(violationTitleInput.toLowerCase())
    );
    
    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredViolations.length / itemsPerPage);
    const [currPage, setCurrPage] = useState(1);
    const currentItems = filteredViolations.slice((currPage - 1) * itemsPerPage, currPage * itemsPerPage);
    
    useEffect(() => {
            
        const activeViolationsQuery = query(
            collection(db, "violations"),
            where("effectiveEndDate", "==", null)
        );
    
        const unsubscribe = onSnapshot(activeViolationsQuery, (querySnapshot) => {
            let violationsArray = querySnapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
    
            if (sortValue === "arsCode-asc") {
                violationsArray.sort((a, b) => a.arsCode.localeCompare(b.arsCode));
            } 
            
            else if (sortValue === "arsCode-desc") {
                violationsArray.sort((a, b) => b.arsCode.localeCompare(a.arsCode));
            } 

            else if (sortValue === "startDate-asc") { 
                violationsArray.sort((a, b) => a.effectiveStartDate.toDate().getTime() - b.effectiveStartDate.toDate().getTime()); 
            } 
              
            else if (sortValue === "startDate-desc") { 
                violationsArray.sort((a, b) => b.effectiveStartDate.toDate().getTime() - a.effectiveStartDate.toDate().getTime()); 
            }
            
            else if (sortValue === "fine-asc") {
                violationsArray.sort((a, b) => parseFloat(a.fine) - parseFloat(b.fine));
            } 
            
            else if (sortValue === "fine-desc") {
                violationsArray.sort((a, b) => parseFloat(b.fine) - parseFloat(a.fine));
            }

            else if (sortValue === "proof-info") {
                violationsArray.sort((a, b) => {
                    const aHasProofOrInfo = hasText(a.acceptableProof) || hasText(a.additionalInfo);
                    const bHasProofOrInfo = hasText(b.acceptableProof) || hasText(b.additionalInfo);
                    if (aHasProofOrInfo === bHasProofOrInfo) return 0;
                    return aHasProofOrInfo ? -1 : 1;
                });
            }
    
            setViolations(prev => {
                if (editViolation) return prev;
                return violationsArray;
            });
                

            if (currPage <= Math.ceil(violationsArray.length / itemsPerPage)) {
                navigate(`/dashboard/page/${currPage}`, { replace: true });
            }

            if (editViolation && !violationsArray.some(v => v.id === editViolation.id)) {
                setEditViolation(null);
            }
        
        }, (error) => {
            console.error("Firestore snapshot error:", error);
        });
    
        return () => unsubscribe();
        
    }, [sortValue, editViolation, navigate, currPage]);

    const handlePageClick = (e) => {
        setCurrPage(e.selected + 1);
        navigate(`/dashboard/page/${e.selected + 1}`);
    }

    
        
    const hasText = (nodes) => {
        if (!Array.isArray(nodes)) return false;
        
        return nodes.some(node => {
            // Check if the node itself is a text node 
            if (Text.isText(node) && node.text && node.text.trim() !== "") {
                return true;
            }
    
            // Check if the node is a block/element (like a paragraph, list item, or link)
            if (Array.isArray(node.children)) {
                // Check the children
                return node.children.some(child => {
                    if (Text.isText(child) && child.text && child.text.trim() !== "") {
                        return true;
                    }
                    
                    if (child.type === 'link') {
                        return true;
                    }
                    
                    return false;
                });
            }
            
            if (node.type === 'link') {
                return true;
            }
    
            return false;
        });
    };

    const showPageTotal = () => {
        if (filteredViolations.length === 0) {
            return <p className="print-page-length">Showing 0 of 0</p>;
        }

        const first = (currPage - 1) * itemsPerPage + 1;
        const last = Math.min( currPage * itemsPerPage, filteredViolations.length);
    
        return (
            <p className="print-page-length">Showing {first} - {last} of {filteredViolations.length}</p>
        );
    };

        
    return (
        <div className="dashboard">
            <UserNavbar setViolationTitleInput={setViolationTitleInput} violationTitleInput={violationTitleInput} setSortValue={setSortValue} 
                sortValue={sortValue} violations={violations} setCurrPage={setCurrPage} setBulkCheck={setBulkCheck}/>
            
            {(bulkCheck) ? <BulkEdit setBulkCheck={setBulkCheck} user={userAuth.email}/>
            : <div>
                {violations.length > 0 ? (
                    <>
                        <ViolationCard currentItems={currentItems} hasText={hasText} setViolations={setViolations} editViolation={editViolation} setEditViolation={setEditViolation}/>

                        {totalPages > 0 && (
                            <ReactPaginate previousLabel={"<"} nextLabel={">"} breakLabel={".."} breakClassName={"break-me"}
                                forcePage={currPage - 1}
                                pageCount={totalPages} 
                                marginPagesDisplayed={2} 
                                pageRangeDisplayed={2}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination"}
                                activeClassName={"active"}/>
                        )} 
                        {showPageTotal()}
                    </>
                    
                ) : (
                    <>
                    <ThreeDots color="#00BFFF" height={80} width={80}/>
                    </>
                    
                )}
            </div>
            }
            
    </div>
    );
}

export default UserDash
